import Lenis from "lenis";

export const lenisRef = { current: null };

export function initLenis() {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return () => {};
  const lenis = new Lenis({ duration: 1.15, easing: (t) => 1 - Math.pow(1 - t, 4), smoothWheel: true });
  lenisRef.current = lenis;
  let id;
  const raf = (time) => { lenis.raf(time); id = requestAnimationFrame(raf); };
  id = requestAnimationFrame(raf);
  return () => { cancelAnimationFrame(id); lenis.destroy(); lenisRef.current = null; };
}

export const scrollToTop = () => {
  if (lenisRef.current) lenisRef.current.scrollTo(0, { immediate: true });
  else window.scrollTo(0, 0);
};

export const setScrollLock = (locked) => {
  if (lenisRef.current) (locked ? lenisRef.current.stop() : lenisRef.current.start());
  document.documentElement.style.overflow = locked ? "hidden" : "";
};
